import { render, staticRenderFns } from "./ContattiView.vue?vue&type=template&id=4f7da68f&scoped=true&"
import script from "./ContattiView.vue?vue&type=script&lang=js&"
export * from "./ContattiView.vue?vue&type=script&lang=js&"
import style0 from "./ContattiView.vue?vue&type=style&index=0&id=4f7da68f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7da68f",
  null
  
)

export default component.exports